import AiInsufficientBalanceModal from '@/app/common/components/AiInsufficientBalanceModal';
import AiFormWarningAlert from '@/app/common/components/AiFormWarningAlert';
import AiNoActiveApiKeyAlert from '@/app/common/components/AiNoActiveApiKeyAlert';
import useSendAiAnalysisForm from '@/app/ContentTools/hooks/useSendAiAnalysisForm';
import AiAnalysisForm, {
  type AiAnalysisFormValues
} from './AiAnalysisForm';

type AiAnalysisSearchBoxProps = {
  initialValues?: Partial<AiAnalysisFormValues>;
};

const AiAnalysisSearchBox = ({ initialValues }: AiAnalysisSearchBoxProps) => {
  const {
    onSubmit,
    isSubmitting,
    showInsufficientBalanceModal,
    setShowInsufficientBalanceModal,
    showNoActiveApiKeyAlert,
    setShowNoActiveApiKeyAlert,
    formWarningMessage,
    setFormWarningMessage
  } = useSendAiAnalysisForm();

  return (
    <>
      <AiAnalysisForm
        onSubmit={onSubmit}
        isSubmitting={isSubmitting}
        initialValues={initialValues}
      />
      <AiNoActiveApiKeyAlert
        show={showNoActiveApiKeyAlert}
        onClose={() => setShowNoActiveApiKeyAlert(false)}
      />
      <AiFormWarningAlert
        message={formWarningMessage}
        onClose={() => setFormWarningMessage(null)}
      />
      <AiInsufficientBalanceModal
        show={showInsufficientBalanceModal}
        onHide={() => setShowInsufficientBalanceModal(false)}
      />
    </>
  );
};

export default AiAnalysisSearchBox;
